<template>
  <c-ticket-container :reservation="reservation">
    <template #title>
      {{ $t('timeSlotOfArrival') }}
    </template>

    <template #default>
      <c-arrival-time :reservation="reservation" />

      <c-headline
        id="special-events"
        class="ticket-selection__heading"
        level="2"
      >
        {{ $t('specialEvents') }}
      </c-headline>

      <c-special-events />
    </template>

    <template
      v-if="cartValidation.valid"
      #banner
    >
      <c-action-link
        :router-link="$t('book.link')"
        color="primary-inverse-dark"
      >
        {{ $t('book.text') }}
        <c-icon
          type="chevron-right"
          :size="0.75"
        />
      </c-action-link>
    </template>

    <template
      v-else-if="reservationsValid"
      #banner
    >
      <c-action-link

        :router-link="$t('reserve.link')"
        color="primary-inverse-dark"
      >
        {{ $t('reserve.text') }}
        <c-icon
          type="chevron-right"
          :size="0.75"
        />
      </c-action-link>
    </template>
  </c-ticket-container>
</template>

<script>
import CActionLink from './actionLink.vue'
import CArrivalTime from './arrivalTime.vue'
import CHeadline from './headline.vue'
import CIcon from './icon.vue'
import CSpecialEvents from './specialEvents.vue'
import CTicketContainer from './CTicketContainer.vue'

import cartValidationMixin from '../mixins/cartValidation.js'

import gapFromTime from '../functions/gapFromTime'
import dateHelper from '../functions/dateHelper'

export default {
  name: 'CTicketSelection',

  components: {
    CTicketContainer,
    CActionLink,
    CArrivalTime,
    CHeadline,
    CIcon,
    CSpecialEvents
  },

  mixins: [cartValidationMixin],

  props: {
    reservation: Boolean
  },

  computed: {
    reservationsValid () {
      if (this.$store.state.cart.reservations.count === 0) {
        return false
      }

      const cartDate = new Date(this.$store.state.cart.reservations.date).setHours(0, 0, 0, 0)
      const today = dateHelper.getDate()

      // Cart is from the past
      if (cartDate < today) {
        return false
      }

      if (cartDate === today) {
        // Cart is for today
        const gap = gapFromTime(new Date())
        if (gap > this.$store.state.cart.reservations.gap) {
          return false
        }
      }

      return true
    }
  }
}
</script>

<i18n locale="en">
{
  "timeSlotOfArrival": "Time Slot of Arrival",
  "specialEvents": "Events",
  "book": {
    "text": "Book now",
    "link": "/booking/overview"
  },
  "reserve": {
    "text": "Reserve now",
    "link": "/reservation/overview"
  }
}
</i18n>

<i18n locale="de">
{
  "timeSlotOfArrival": "Ankunftszeit",
  "specialEvents": "Sonderveranstaltungen",
  "book": {
    "text": "Jetzt buchen",
    "link": "/buchung/uebersicht"
  },
  "reserve": {
    "text": "Jetzt reservieren",
    "link": "/reservierung/uebersicht"
  }
}
</i18n>

<style lang="scss">
@import "../css/variables";

.ticket-selection__heading {
  margin-top: $gutter-md;
  margin-bottom: $gutter-sm;

  text-align: center;

  @media (min-width: $breakpoint-md) {
    margin-top: $gutter-lg;
    margin-bottom: $gutter-md;
  }
}
</style>
